export default "/images/af4692076fb312530181df4c7c9a9c3e.png";